import { useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { get } from '../apiClient'
import { messageThreadSchema } from '../../../common/validations/residentMessageTimelineSchema'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

export const residentMessageThreadKey = (
  contractUuid: string,
  threadUuid: string
) => ['resident-message-thread', contractUuid, threadUuid] as const

const path = (contractUuid: string, threadUuid: string) =>
  API_ENDPOINTS.MESSAGE_THREAD.replace(':contractUuid', contractUuid).replace(
    ':threadUuid',
    threadUuid
  )

const params = (contractUuid: string, threadUuid: string) => ({
  queryKey: residentMessageThreadKey(contractUuid, threadUuid),
  queryFn: async () => {
    const response = await get(
      path(contractUuid, threadUuid),
      messageThreadSchema
    )
    return response
  },
  staleTime: 0,
})

export const useAPIGetResidentMessageThread = (threadUuid: string) => {
  const { currentContractId: contractUuid } = useCurrentContract()

  return useSuspenseQuery(params(contractUuid, threadUuid))
}
